import React from 'react';
import { Div, Group, Header, Panel, Text } from '@vkontakte/vkui';
import { AppShell, ScreenHeader } from '../../components/Layout/AppShell';
import { RatingEntryCard } from '../../components/Rating/RatingEntryCard';
import { EmptyState } from '../../components/States/States';
import { RATING_PANEL } from '../../routing/routing';

export function RatingPanel({ nav = RATING_PANEL, rating, loading, currentUserRating, currentPlayerID, onBack }) {
  return (
    <Panel nav={nav}>
      <ScreenHeader title="Рейтинг учеников" onBack={onBack} />
      <AppShell>
        <Group>
          <Div>
            <Text>Рейтинг показывает ТОП-50 учеников по количеству выученных слов.</Text>
            <Text className="mt-2 text-[var(--vkui--color_text_secondary)]">
              Регулярные тренировки помогают постепенно подняться выше.
            </Text>
          </Div>
        </Group>

        <Group header={<Header>Лучшие ученики</Header>}>
          {rating?.entries?.length ? (
            rating.entries.map((item) => (
              <RatingEntryCard key={item.player.id} item={item} currentPlayerID={currentPlayerID} />
            ))
          ) : !loading ? <EmptyState /> : null}
        </Group>

        {rating && !rating.in_top && currentUserRating ? (
          <Group header={<Header>Ваш результат</Header>}>
            <Div>
              <Text className="mb-3 text-[var(--vkui--color_text_secondary)]">Вы пока не попадаете в ТОП-50, но результат уже учитывается.</Text>
            </Div>
            <RatingEntryCard item={currentUserRating} currentPlayerID={currentPlayerID} compact />
          </Group>
        ) : null}
      </AppShell>
    </Panel>
  );
}
